module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_9016.c16b784d.png";